import {
  createPlugin,
  createRoutableExtension,
  createRouteRef,
} from '@backstage/core-plugin-api';

export const testReportGeneratorRouteRef = createRouteRef({
  id: 'test-report-generator',
});

export const testReportGeneratorPlugin = createPlugin({
  id: 'test-report-generator',
  routes: {
    root: testReportGeneratorRouteRef,
  },
});

export const TestReportGeneratorPage =
  testReportGeneratorPlugin.provide(
    createRoutableExtension({
      name: 'TestReportGeneratorPage',
      mountPoint: testReportGeneratorRouteRef,
      component: () =>
        import('./components/TestReportGeneratorPage').then(
          module => module.TestReportGeneratorPage,
        ),
    }),
  );
